export interface FontTheme {
  id: string;
  labelKey: string;        // translation key
  sans: string;            // full font-family stack
  mono: string;            // full font-family stack
  googleFontsUrl?: string; // URL for <link> tag
  selfHostedFontCss?: string; // @font-face CSS to inject
}

export const FONT_THEMES: Record<string, FontTheme> = {
  system: {
    id: "system",
    labelKey: "settings:appearance.system",
    sans: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
  },
  inter: {
    id: "inter",
    labelKey: "settings:appearance.inter",
    sans: '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"IBM Plex Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
    googleFontsUrl: "https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap",
  },
  "space-grotesk": {
    id: "space-grotesk",
    labelKey: "settings:appearance.spaceGrotesk",
    sans: '"Space Grotesk", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"Fira Code", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
    googleFontsUrl: "https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600;700&family=Space+Grotesk:wght@300;400;500;600;700&display=swap",
  },
  "space-grotesk-geist": {
    id: "space-grotesk-geist",
    labelKey: "settings:appearance.spaceGroteskGeist",
    sans: '"Space Grotesk", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"Geist Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
    googleFontsUrl: "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap",
    selfHostedFontCss: `@font-face { font-family: "Geist Mono"; src: url("/fonts/GeistMono-Regular.woff2") format("woff2"); font-weight: 400; font-style: normal; font-display: swap; } @font-face { font-family: "Geist Mono"; src: url("/fonts/GeistMono-Medium.woff2") format("woff2"); font-weight: 500; font-style: normal; font-display: swap; } @font-face { font-family: "Geist Mono"; src: url("/fonts/GeistMono-SemiBold.woff2") format("woff2"); font-weight: 600; font-style: normal; font-display: swap; } @font-face { font-family: "Geist Mono"; src: url("/fonts/GeistMono-Bold.woff2") format("woff2"); font-weight: 700; font-style: normal; font-display: swap; }`,
  },
};

export const DEFAULT_THEME_ID = "system";
export const FONT_THEME_STORAGE_KEY = "fontTheme";
